module.exports = __webpack_public_path__ + "static/media/batman-profile.a96b6b35.jpg";